export default __webpack_public_path__ + "static/media/sofa-3-seat-1-back.a806a100.webp";